import React, { useMemo, useState, useContext, useRef } from "react";
import {
  Fade,
  MenuItem,
  useTheme,
  Typography,
  Menu,
  Box,
  TextField,
  ClickAwayListener,
  Avatar,
  IconButton,
  FormControlLabel,
  Checkbox,
  Popper,
  Paper,
  Stack,
  Collapse,
  Divider,
  Button,
  Portal,
} from "@mui/material";
import {
  orderCompaniesAlphabetically,
  selectAllCompanies,
} from "../../features";
import PlaceIcon from "@mui/icons-material/Place";
import { AppContext } from "../../contextProviders/AppContext";
import { translation } from "../../components/Dictionary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
const FIXED_GROUPS = window.URENT_APP_GROUPS;
const FEATURE_SELECT_CUSTOM_LABEL = FIXED_GROUPS?.includes("rsteam")
  ? true
  : false;

export default function RentalServiceSelector({
  inputClassName,
  fullWidth,
  providerSelectOpen,
  setProviderSelectOpen,
  contentHeigth,
}) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedPickup, setSelectedPickup] = useState(null);
  const [selectedReturn, setSelectedReturn] = useState(null);
  const [differentReturn, setDifferentReturn] = useState(false);
  function handleSelect(company) {
    setSelectedPickup(company);
  }

  const {
    companies,
    handleSelectedCompany,
    selectedCompany,
    language,
    mobileViewPort,
    setOffers,
    enableCustomProviderLabel,
    FEATURE_NO_TIME_SELECT,
  } = useContext(AppContext);

  useEffect(() => {
    handleSelectedCompany(selectedReturn);
  }, [selectedReturn]);

  const FEATURE_HIDE_SELECTED_COMPANY_TITLE = useMemo(() => {
    if (
      selectedCompany?.group === "gnista" ||
      selectedCompany?.group === "huuma"
    ) {
      return true;
    }
  }, [selectedCompany]);

  const provideSelectorLabel = useMemo(() => {
    if (enableCustomProviderLabel()) {
      return enableCustomProviderLabel();
    }
    return translation.get(language, "Provider default title");
  }, [language]);

  const [focus, setFocus] = useState(false);
  const inputRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [openMenuReturn, setOpenMenuReturn] = useState(false);

  const onFocus = () => {
    setFocus(true);
  };

  const onBlur = () => {
    setFocus(false);
  };
  /*   useEffect(() => {
    if (focus) {
      inputRef?.current.focus();
    }
  }, [focus]); */

  const [companyId, setCompanyId] = useState(selectedCompany?.id ?? "none");

  const [dirty, setDirty] = useState(false);

  // Be careful with this setting, as it will not behave correctly if all Companys
  // within the group use the same settings
  const FEATURE_SELECT_ALL_COMPANIES = selectAllCompanies(companies);

  const orderedCompanies = useMemo(() => {
    if (orderCompaniesAlphabetically(companies[0])) {
      return [...companies].sort((c1, c2) => {
        if (c1.displayName < c2.displayName) {
          return -1;
        }
        if (c1.displayName > c2.displayName) {
          return 1;
        }
        return 0; // Names are equal
      });
    }
    //Only sorts if both of our c1 & c2 orderNumbers are null or numbers (null - null = 0, so the order doesn't change)
    return [...companies].sort((c1, c2) => {
      return (
        (c1.orderNumber === null) - (c2.orderNumber === null) ||
        c1.orderNumber - c2.orderNumber
      );
    });
  }, [companies]);
  const groups = window.URENT_APP_GROUPS;

  const serviceType = "legacy"; //"legacy" or "organization"
  const chooseCompanyLabel = useMemo(() => {
    if (enableCustomProviderLabel())
      return translation.get(language, "Select product group");
    return translation.get(language, "Select company label");
  }, [language]);

  const [selected, setSelected] = useState();
  const handleChangeCompany = (id) => {
    setCompanyId(id);
    if (id === "all") {
      // Set company with  suitable settings, and id "all"
      handleSelectedCompany(FEATURE_SELECT_ALL_COMPANIES);
    } else {
      handleSelectedCompany(companies.find((c) => c.id === id));
    }
  };

  const openMenu = (e) => {
    setProviderSelectOpen(!providerSelectOpen);
    setOpen((prevState) => !prevState);
    setAnchorEl(e.currentTarget);
  };

  const handleopenMenuReturn = (e) => {
    setProviderSelectOpen(!providerSelectOpen);
    setOpenMenuReturn((prevState) => !prevState);
    setAnchorEl(e.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setProviderSelectOpen(false);
    setOpen(false);
    setOpenMenuReturn(false);
  };

  const closeMenuReturn = () => {
    setAnchorEl(null);
    setProviderSelectOpen(false);
    setOpenMenuReturn(false);
  };
  const handleClickMenuItem = (e) => {
    if (serviceType === "legacy") {
      setAnchorEl(null);
      handleSelectedCompany(e);
      setOffers([]);
      setOpen(false);
      setProviderSelectOpen(false);
    }
    if (serviceType === "organization") {
      setSelectedPickup(e);
      setOffers([]);

      setProviderSelectOpen(false);
    }
  };
  const [searchInput, setSearchInput] = useState("");
  const [searchInputReturn, setSearchInputReturn] = useState("");

  const searchResultsPickup = useMemo(() => {
    const result = orderedCompanies.filter((company) => {
      const name = company?.displayName ?? company?.name;
      if (name.toLowerCase().includes(searchInput.toLowerCase())) {
        return company;
      }
      return null;
    });

    if (result) {
      return result;
    }
    if (!searchInput) {
      return [];
    }
  }, [orderedCompanies, searchInput]);

  const searchResultsReturn = useMemo(() => {
    const result = orderedCompanies.filter((company) => {
      const name = company?.displayName ?? company?.name;
      if (name.toLowerCase().startsWith(searchInputReturn)) {
        return company;
      }
      return null;
    });

    if (result) {
      return result;
    }
    if (!searchInputReturn) {
      return [];
    }
  }, [orderedCompanies, searchInputReturn]);

  function advanceFromSelectCompany() {
    if (!differentReturn) {
      setAnchorEl(null);
      setProviderSelectOpen(false);
    } else {
      setSelectedReturn(selectedPickup);
      closeMenu();
    }
  }

  const styles = {
    width: FEATURE_NO_TIME_SELECT ? "35%" : "25%",
    height: contentHeigth,
    paddingLeft: "3px",
    boxShadow: providerSelectOpen ? theme.shadows[2] : "transparent",
    /*   bgcolor: mobileViewPort
    ? theme.palette.primary.dialogBackground
    : undefined, */
    border: undefined,
    borderRadius: undefined,
    cursor: "pointer",
    borderTopLeftRadius: "45px",
    borderBottomLeftRadius: " 45px",
    borderTopRightRadius: "10px",
    borderBottomRightRadius: "10px",
    transition: "250ms ease-in-out",
    backgroundColor: Boolean(anchorEl) ? "white" : "transparent",
    "&:hover": {
      bgcolor: "rgba(0,0,0,0.05)",
      boxShadow: theme.shadows[2],
    },
    marginLeft: "2px",
    marginRight: "10px",
  };

  const mobileStyles = {
    width: "100%",
    margin: "10px",
    boxShadow: providerSelectOpen ? theme.shadows[2] : "transparent",
    /*   bgcolor: mobileViewPort
          ? theme.palette.primary.dialogBackground
          : undefined, */
    border: mobileViewPort ? "1px solid lightgrey" : undefined,
    borderRadius: mobileViewPort ? "15px" : undefined,
    cursor: "pointer",
    transition: "250ms ease-in-out",
    backgroundColor: "white",
    "&:hover": {
      bgcolor: "rgba(0,0,0,0.05)",
    },
  };

  return (
    <Box sx={mobileViewPort ? mobileStyles : styles}>
      <Box
        sx={{
          marginLeft: "2px",
          marginRight: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          height: contentHeigth,
          borderTopLeftRadius: "45px",
          borderBottomLeftRadius: "45px",
        }}
        onClick={(e) => openMenu(e)}
      >
        {providerSelectOpen && (
          <Box
            sx={{
              display: "flex",
              width: "90%",
              marginLeft: "15px",
              marginTop: "10px",
              flexDirection: "column",
            }}
          >
            <Typography> {chooseCompanyLabel}</Typography>
          </Box>
        )}
        <Box sx={{ marginLeft: "15px" }}>
          {selectedCompany && !providerSelectOpen && (
            <Box>
              {!FEATURE_HIDE_SELECTED_COMPANY_TITLE && (
                <Typography
                  sx={{
                    color: theme.palette.primary.mainText,
                    fontSize: "16px",
                    fontFamily: "Sofia Pro",
                    fontWeight: 500,
                  }}
                >
                  {translation.get(language, "Selected company")}
                </Typography>
              )}

              <Typography
                variant="body1"
                sx={{
                  fontWeight: 700,
                  color: theme.palette.primary.mainText,
                }}
              >
                {selectedCompany.displayName}
              </Typography>
            </Box>
          )}
          {!selectedCompany && !providerSelectOpen && (
            <Box>
              <Typography
                sx={{
                  color: theme.palette.primary.mainText,
                  fontSize: "16px",
                  fontFamily: "Sofia Pro",
                }}
              >
                {provideSelectorLabel}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.primary.mainText,
                }}
              >
                {chooseCompanyLabel}
              </Typography>
            </Box>
          )}
        </Box>
        <ExpandMoreIcon sx={{ color: "lightgrey" }} />
      </Box>

      {mobileViewPort && serviceType === "organization" && (
        <>
          <Divider sx={{ marginY: "5px" }} />
          <Box
            sx={{
              marginLeft: "2px",
              marginRight: "10px",

              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              height: contentHeigth,
              borderTopLeftRadius: "45px",
              borderBottomLeftRadius: "45px",
            }}
            onClick={(e) => handleopenMenuReturn(e)}
          >
            {providerSelectOpen && (
              <Box
                sx={{
                  display: "flex",
                  width: "90%",
                  marginLeft: "15px",
                  marginTop: "10px",
                  flexDirection: "column",
                }}
              >
                <Typography>Palautuspaikka</Typography>
              </Box>
            )}
            <Box sx={{ marginLeft: "15px" }}>
              {selectedCompany && !providerSelectOpen && (
                <Box>
                  {!FEATURE_HIDE_SELECTED_COMPANY_TITLE && (
                    <Typography
                      sx={{
                        color: theme.palette.primary.mainText,
                        fontSize: "16px",
                        fontFamily: "Sofia Pro",
                        fontWeight: 500,
                      }}
                    >
                      {/*     {translation.get(language, "Selected company")} */}
                      Palautus
                    </Typography>
                  )}

                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.primary.mainText,
                    }}
                  >
                    {selectedCompany.displayName}
                  </Typography>
                </Box>
              )}
              {!selectedCompany && !providerSelectOpen && (
                <Box>
                  <Typography
                    sx={{
                      color: theme.palette.primary.mainText,
                      fontSize: "16px",
                      fontFamily: "Sofia Pro",
                    }}
                  >
                    Palautus
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.primary.mainText,
                    }}
                  >
                    {chooseCompanyLabel}
                  </Typography>
                </Box>
              )}
            </Box>
            <ExpandMoreIcon sx={{ color: "lightgrey" }} />
          </Box>
        </>
      )}

      <Popper
        anchorEl={anchorEl}
        open={open}
        style={{ zIndex: 9999 }}
        placement="bottom-start"
      >
        <Paper
          sx={{
            //   marginLeft: "10px",
            borderRadius: "14px",
            marginTop: mobileViewPort ? "2px" : "20px",
            padding: "5px",
            //   maxHeight: mobileViewPort ? undefined : "400px",

            //   height: mobileViewPort ? "100vh" : undefined,
            //      width: mobileViewPort ? "100vw" : undefined,
            //     minHeight: mobileViewPort ? undefined : "130px",
            //  minWidth: differentReturn ? "700px" : "300px",
            overflow: "hidden",
          }}
        >
          <Stack direction={mobileViewPort ? "column" : "row"}>
            <Box
              sx={{
                minWidth: "300px",
                overflow: "auto",
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                maxHeight: "400px",
              }}
            >
              {orderedCompanies.length > 5 && (
                <TextField
                  autoFocus
                  key={"searchInputField"}
                  fullWidth
                  id="searchInputField"
                  variant="outlined"
                  value={searchInput}
                  focused={true}
                  //    inputRef={(input) => input && input.focus()}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onChange={(e) => setSearchInput(e.target.value)}
                  //   InputProps={{ disableUnderline: true }}
                  label="Valitse noutopiste"
                  sx={{ zIndex: 9999, marginY: "10px" }}
                />
              )}
              {serviceType === "organization" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      name="billPayment"
                      checked={!differentReturn}
                      color="success"
                      onChange={() =>
                        setDifferentReturn((prevState) => !prevState)
                      }
                    />
                  }
                  label={<>Sama palautuspaikka</>}
                />
              )}

              <SelectedPickupLocation
                selectedPickup={
                  serviceType === "legacy" ? selectedCompany : selectedPickup
                }
                setSelectedPickup={setSelectedPickup}
                remove={
                  serviceType === "legacy"
                    ? null
                    : () => setSelectedPickup(null)
                }
                title={
                  serviceType === "legacy"
                    ? "Valittu toimipiste"
                    : "Valittu noutopiste"
                }
              />

              <Box
                sx={{
                  overflow: "auto",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {searchResultsPickup.map((company) => (
                  <MenuItem
                    key={company.id}
                    //  onClick={() => handleClickMenuItem(company)}
                    onClick={() => handleClickMenuItem(company)}
                    sx={{ padding: "15px", borderRadius: "15px" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Avatar
                        variant="rounded"
                        sx={{
                          marginRight: "10px",
                          bgcolor: "rgba(0,0,0,0.10)",
                        }}
                      >
                        <PlaceIcon sx={{ color: "rgba(0,0,0,0.65)" }} />
                      </Avatar>

                      <Typography variant="body1" sx={{ fontSize: "16px" }}>
                        {company.displayName ?? company.name}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Box>
            </Box>

            <SelectReturnLocation
              searchInputReturn={searchInputReturn}
              setSearchInputReturn={setSearchInputReturn}
              selectedReturn={selectedReturn}
              onFocus={onFocus}
              onBlur={onBlur}
              setSelectedReturn={setSelectedReturn}
              searchResultsReturn={searchResultsReturn}
              visibility={differentReturn && !mobileViewPort}
            />
          </Stack>
          {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={() => closeMenu()}
              variant="contained"
              color="success"
              sx={{ borderRadius: "14px", paddingY: "5px", paddingX: "20px" }}
            >
              Valmis
            </Button>
          </Box> */}
        </Paper>
      </Popper>

      <Popper
        anchorEl={anchorEl}
        open={openMenuReturn}
        style={{ zIndex: 9999 }}
        placement="bottom-start"
      >
        <Paper
          sx={{
            //   marginLeft: "10px",
            borderRadius: "14px",
            marginTop: mobileViewPort ? "2px" : "20px",
            padding: "5px",
            //   maxHeight: mobileViewPort ? undefined : "400px",

            //   height: mobileViewPort ? "100vh" : undefined,
            //      width: mobileViewPort ? "100vw" : undefined,
            //     minHeight: mobileViewPort ? undefined : "130px",
            //  minWidth: differentReturn ? "700px" : "300px",
            overflow: "hidden",
          }}
        >
          <SelectReturnLocation
            searchInputReturn={searchInputReturn}
            setSearchInputReturn={setSearchInputReturn}
            selectedReturn={selectedReturn}
            onFocus={onFocus}
            onBlur={onBlur}
            setSelectedReturn={setSelectedReturn}
            searchResultsReturn={searchResultsReturn}
            visibility={true}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={() => closeMenu()}
              variant="contained"
              color="success"
              sx={{ borderRadius: "14px", paddingY: "5px", paddingX: "20px" }}
            >
              Valmis
            </Button>
          </Box>
        </Paper>
      </Popper>
    </Box>
  );
}

function SelectedPickupLocation(props) {
  const { selectedPickup, setSelectedPickup, remove, title } = props;
  if (!selectedPickup) return null;

  return (
    <Fade in={!!selectedPickup} timeout={400}>
      <MenuItem
        //onClick={() => handleClickMenuItem(company)}
        sx={{
          padding: "10px",
          paddingTop: "2px",
          borderRadius: "15px",
          //    border: "1px solid rgba(0,0,0,0.25)",
          marginBottom: "5px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontSize: "16px", fontWeight: 600 }}
            >
              {title}
            </Typography>
            {remove && (
              <Box>
                <IconButton size="small" onClick={remove}>
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
          </Box>
          <Typography variant="caption">
            {selectedPickup?.displayName ?? selectedPickup?.name}
          </Typography>
          <Divider flexItem />
        </Box>
      </MenuItem>
    </Fade>
  );
}

function SelectReturnLocation(props) {
  const {
    searchInputReturn,
    setSearchInputReturn,
    selectedReturn,
    onFocus,
    onBlur,
    setSelectedReturn,
    searchResultsReturn,
    visibility,
  } = props;
  if (visibility)
    return (
      <Box
        sx={{
          minWidth: "300px",
          overflow: "auto",
          padding: "10px",
          height: "320px",
          border: "1px solid rgba(0,0,0,0.15)",
          borderWidth: "0px 0px 0px 1px",
          display: "flex",
          flexDirection: "column",
          marginTop: "10px",
        }}
      >
        <TextField
          key={"searchInputField"}
          fullWidth
          id="searchInputField"
          variant="outlined"
          value={searchInputReturn}
          focused={true}
          //    inputRef={(input) => input && input.focus()}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={(e) => setSearchInputReturn(e.target.value)}
          //   InputProps={{ disableUnderline: true }}
          label="Valitse palautuspaikka"
          sx={{ zIndex: 9999, marginBottom: "42px" }}
        />
        {selectedReturn && (
          <Fade in={!!selectedReturn} timeout={400}>
            <MenuItem
              //onClick={() => handleClickMenuItem(company)}
              sx={{
                padding: "10px",
                paddingTop: "2px",
                borderRadius: "15px",
                //  border: "1px solid rgba(0,0,0,0.25)",
                marginBottom: "5px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",

                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontSize: "16px", fontWeight: 600 }}
                  >
                    Valittu palautus
                  </Typography>
                  <Box>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSelectedReturn(null);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Box>
                <Typography variant="caption">
                  {selectedReturn?.displayName ?? selectedReturn?.name}
                </Typography>
                <Divider flexItem />
              </Box>
            </MenuItem>
          </Fade>
        )}
        <Box sx={{ overflow: "auto" }}>
          {searchResultsReturn.map((company) => (
            <MenuItem
              key={company.id}
              //  onClick={() => handleClickMenuItem(company)}
              onClick={() => {
                setSelectedReturn(company);
              }}
              sx={{ padding: "15px", borderRadius: "15px" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Avatar
                  variant="rounded"
                  sx={{
                    marginRight: "10px",
                    bgcolor: "rgba(0,0,0,0.10)",
                  }}
                >
                  <PlaceIcon sx={{ color: "rgba(0,0,0,0.65)" }} />
                </Avatar>

                <Typography variant="body1" sx={{ fontSize: "16px" }}>
                  {company.displayName ?? company.name}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Box>
      </Box>
    );
}
